export default function(http) {
  return {
    queryByPage(data) {
      return http({

      });
    },
  };
}



// WEBPACK FOOTER //
// ./src/configure/http/api/index.js